module.exports = __webpack_public_path__ + "img/leeside.d2230e5c.gif";